const IP = process.env.NODE_ENV === 'production' ? 'nomu.strategy-offsite-meeting.com' : 'snb-nomu-be.onrender.com';
// const IP = "snb-nomu-be.onrender.com"


export default IP;


